import { PropTypes } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import { Archive } from "@material-ui/icons";
import { observer } from "mobx-react";
import React from "react";
import { OneDataSource } from "../../dataAccess/DataSource";

export interface DownloadButtonProps<T, ID> {
  color?: PropTypes.Color;
  dataSource?: OneDataSource<T, ID>;
  url: string;
}

@observer
export class DownloadButton<T extends object, ID> extends React.Component<
  DownloadButtonProps<T, ID>
> {
  public render() {
    return (
      <Tooltip title="Download uploaded file">
        <IconButton
          aria-label="Download uploaded file"
          color={this.props.color}
          onClick={this.downloadFile}
        >
          <Archive />
        </IconButton>
      </Tooltip>
    );
  }

  public downloadFile = async () => {
    if (this.props.dataSource) {
      await this.props.dataSource.download(this.props.url);
    }
  };
}
